import { useFeatureFlag } from '@fs/zion-flags'

/**
 * Which curated historical list the console is working with.
 *
 * DATA-12381 gives the rebuilt historical queue a list of its own, distinguished by `metaDataId`. The
 * `matchType` stays 'HISTORICAL' on both, because that says what shape a record is, not which list it
 * belongs to -- the worker's `standardizePerson` and `validateJson` both branch on it.
 *
 * Kept in one place so the flag is read once. Reading it in each component invites the two lists to
 * disagree about which one is showing.
 */
export const HISTORICAL_META_DATA_ID = 2
export const HISTORICAL_V2_META_DATA_ID = 3

/** The `{matchType}` path segment for the worker's list endpoints. Not the same as a record's matchType. */
export const HISTORICAL_LIST_NAME = 'historical'
export const HISTORICAL_V2_LIST_NAME = 'historical_v2'

export function useHistoricalList() {
  const v2IsOn = useFeatureFlag('tree_admin_dmcsonsole_historical').isOn
  return {
    v2IsOn,
    metaDataId: v2IsOn ? HISTORICAL_V2_META_DATA_ID : HISTORICAL_META_DATA_ID,
    listName: v2IsOn ? HISTORICAL_V2_LIST_NAME : HISTORICAL_LIST_NAME,
  }
}
